export enum CheckedOutStatus {
  CheckedIn = 0,
  CheckedOutToOtherUser = 1,
  CheckedOutToCurrentUser = 2,
}
